import { useEffect } from "react";
import { defaultAvatarImages } from "../../domains/user/utils/pickUserImage";
import {
  DEFAULT_PROFILE_PICTURES,
  DefaultProfilePicture,
} from "../../../../api/src/shared/domain/user";
import { cn } from "../../lib/utils";

export default function DefaultAvatarSelector({
  selected,
  onChange,
  disabled = false,
}: {
  selected: DefaultProfilePicture | "";
  onChange: (slug: DefaultProfilePicture) => void;
  disabled?: boolean;
}) {
  useEffect(() => {
    if (selected !== "" && selected in defaultAvatarImages) {
      handleSelect(selected, true);
    }
  }, [selected]);

  function handleSelect(slug: DefaultProfilePicture, force = false) {
    if (slug !== selected || force) {
      onChange(slug);
    }
  }

  return (
    <div className="box-border mx-auto grid grid-cols-3 gap-[25px]">
      {DEFAULT_PROFILE_PICTURES.map((slug) => {
        const imgSet = defaultAvatarImages[slug];
        return (
          <img
            key={slug}
            className={cn(
              "box-border mx-auto h-[81px] w-[81px] rounded-full border-[3px] border-transparent",
              selected === slug && "border-primary-black"
            )}
            src={imgSet[disabled ? "disabled" : "default"]}
            alt=""
            onClick={() => {
              if (disabled) return;
              handleSelect(slug);
            }}
          />
        );
      })}
    </div>
  );
}
